import clsx from 'clsx';
import Link from 'next/link';
import Chevron from '../../../svg/ChevronLeft15.svg';
import styles from './WinWithFriendsBadge.module.css';

interface WinWithFriendsBadgeProps {
  backgroundColor?: 'white' | 'lightGrey';
}

export const WinWithFriendsBadge = ({
  backgroundColor = 'white',
}: WinWithFriendsBadgeProps) => {
  return (
    <Link href="/referrals">
      <a href="/referrals">
        <div
          className={clsx(
            styles.container,
            backgroundColor === 'lightGrey'
              ? styles.backgroundLightGrey
              : styles.backgroundWhite,
          )}
        >
          <div className={styles.badgeImage}>
            <img
              src="https://daymade-website-assets.s3.amazonaws.com/2026/referrals/win-with-friends-badge.svg"
              alt=""
            />
          </div>
          <div className={styles.badgeText}>You're playing with friends!</div>
          <div className={styles.chevron}>
            <Chevron />
          </div>
        </div>
      </a>
    </Link>
  );
};
